export type TiktokScope = {
  level: number;
  id: string;
  name: string;
  endpoint?: string;
};

export const ALL_TIKTOK_SCOPES: TiktokScope[] = [
  {
    level: 1,
    id: "1",
    name: "Ad Account Management",
  },
  {
    level: 1,
    id: "2",
    name: "Ads Management",
  },
  {
    level: 1,
    id: "3",
    name: "Audience Management",
  },
  {
    level: 1,
    id: "4",
    name: "Reporting",
  },
  {
    level: 1,
    id: "5",
    name: "Measurement",
  },
  {
    level: 1,
    id: "6",
    name: "Creative Management",
  },
  {
    level: 1,
    id: "7",
    name: "App Management",
  },
  {
    level: 1,
    id: "8",
    name: "Pixel Management",
  },
  {
    level: 1,
    id: "9",
    name: "DPA Catalog Management",
  },
  {
    level: 1,
    id: "10000",
    name: "Reach &amp; Frequency",
  },
  {
    level: 1,
    id: "12000000",
    name: "Lead Management",
  },
  {
    level: 1,
    id: "13000000",
    name: "TikTok Creator Marketplace (TCM)",
  },
  {
    level: 1,
    id: "14000000",
    name: "TikTok Creator",
  },
  {
    level: 1,
    id: "15000000",
    name: "Ad Comments",
  },
  {
    level: 1,
    id: "16000000",
    name: "TikTok business plugin",
  },
  {
    level: 1,
    id: "17000000",
    name: "Automated Rules",
  },
  {
    level: 1,
    id: "18000000",
    name: "TikTok Accounts",
  },
  {
    level: 1,
    id: "19000000",
    name: "Onsite Commerce Store",
    endpoint: "/commerce/store/create/",
  },
  {
    level: 1,
    id: "19000000",
    name: "Onsite Commerce Store",
    endpoint: "/commerce/store/bind_to_catalog/",
  },
  {
    level: 1,
    id: "19000000",
    name: "Onsite Commerce Store",
    endpoint: "/commerce/window/update/",
  },
  {
    level: 1,
    id: "19000000",
    name: "Onsite Commerce Store",
    endpoint: "/commerce/store/get/",
  },
  {
    level: 1,
    id: "19000000",
    name: "Onsite Commerce Store",
    endpoint: "/commerce/store/product/get/",
  },
  {
    level: 1,
    id: "19000000",
    name: "Onsite Commerce Store",
    endpoint: "/commerce/store/trusted_create/",
  },
  {
    level: 1,
    id: "19000000",
    name: "Onsite Commerce Store",
    endpoint: "/store/list/",
  },
  {
    level: 1,
    id: "7043626160646946818",
    name: "Offline Events Management",
  },
  {
    level: 1,
    id: "7050363942434013185",
    name: "Ad Diagnosis",
  },
  {
    level: 1,
    id: "7294180478502830081",
    name: "CRM Event Management",
  },
  {
    level: 2,
    id: "10",
    name: "Ad Account Information",
  },
  {
    level: 2,
    id: "12",
    name: "Terms and Agreements",
  },
  {
    level: 2,
    id: "13",
    name: "Pangle Block List Management",
  },
  {
    level: 2,
    id: "14",
    name: "Pangle Audience Packages",
  },
  {
    level: 2,
    id: "15",
    name: "Business Center",
  },
  {
    level: 2,
    id: "20",
    name: "Campaign",
  },
  {
    level: 2,
    id: "21",
    name: "Ad Group",
  },
  {
    level: 2,
    id: "22",
    name: "Ad",
  },
  {
    level: 2,
    id: "23",
    name: "Change Log",
  },
  {
    level: 2,
    id: "24",
    name: "Split Test",
  },
  {
    level: 2,
    id: "7133464587805982722",
    name: "Search Ads",
  },
  {
    level: 2,
    id: "30",
    name: "Read Custom Audiences",
    endpoint: "/dmp/custom_audience/list/",
  },
  {
    level: 2,
    id: "30",
    name: "Read Custom Audiences",
    endpoint: "/dmp/custom_audience/get/",
  },
  {
    level: 2,
    id: "30",
    name: "Read Custom Audiences",
    endpoint: "/dmp/saved_audience/list/",
  },
  {
    level: 2,
    id: "31",
    name: "Create and Update Custom Audiences",
    endpoint: "/dmp/custom_audience/file/upload/",
  },
  {
    level: 2,
    id: "31",
    name: "Create and Update Custom Audiences",
    endpoint: "/dmp/custom_audience/create/",
  },
  {
    level: 2,
    id: "31",
    name: "Create and Update Custom Audiences",
    endpoint: "/dmp/custom_audience/update/",
  },
  {
    level: 2,
    id: "31",
    name: "Create and Update Custom Audiences",
    endpoint: "/dmp/custom_audience/delete/",
  },
  {
    level: 2,
    id: "31",
    name: "Create and Update Custom Audiences",
    endpoint: "/dmp/custom_audience/rule/create/",
  },
  {
    level: 2,
    id: "31",
    name: "Create and Update Custom Audiences",
    endpoint: "/dmp/custom_audience/lookalike/create/",
  },
  {
    level: 2,
    id: "31",
    name: "Create and Update Custom Audiences",
    endpoint: "/segment/audience/",
  },
  {
    level: 2,
    id: "31",
    name: "Create and Update Custom Audiences",
    endpoint: "/segment/mapping/",
  },
  {
    level: 2,
    id: "31",
    name: "Create and Update Custom Audiences",
    endpoint: "/dmp/custom_audience/apply/",
  },
  {
    level: 2,
    id: "31",
    name: "Create and Update Custom Audiences",
    endpoint: "/dmp/custom_audience/apply/log/",
  },
  {
    level: 2,
    id: "31",
    name: "Create and Update Custom Audiences",
    endpoint: "/dmp/custom_audience/lookalike/update/",
  },
  {
    level: 2,
    id: "31",
    name: "Create and Update Custom Audiences",
    endpoint: "/dmp/saved_audience/delete/",
  },
  {
    level: 2,
    id: "31",
    name: "Create and Update Custom Audiences",
    endpoint: "/dmp/saved_audience/create/",
  },
  {
    level: 2,
    id: "32",
    name: "Share Custom Audiences",
    endpoint: "/dmp/custom_audience/share/cancel/",
  },
  {
    level: 2,
    id: "32",
    name: "Share Custom Audiences",
    endpoint: "/dmp/custom_audience/share/log/",
  },
  {
    level: 2,
    id: "32",
    name: "Share Custom Audiences",
    endpoint: "/dmp/custom_audience/share/",
  },
  {
    level: 2,
    id: "40",
    name: "Ad Account Level",
  },
  {
    level: 2,
    id: "41",
    name: "Campaign Level",
  },
  {
    level: 2,
    id: "42",
    name: "Ad Group Level",
  },
  {
    level: 2,
    id: "43",
    name: "Ad Level",
  },
  {
    level: 2,
    id: "44",
    name: "Consolidated Report",
    endpoint: "/report/integrated/get/",
  },
  {
    level: 2,
    id: "44",
    name: "Consolidated Report",
    endpoint: "/report/task/download/",
  },
  {
    level: 2,
    id: "44",
    name: "Consolidated Report",
    endpoint: "/report/task/create/",
  },
  {
    level: 2,
    id: "44",
    name: "Consolidated Report",
    endpoint: "/report/task/check/",
  },
  {
    level: 2,
    id: "44",
    name: "Consolidated Report",
    endpoint: "/report/subscription/subscribe/",
  },
  {
    level: 2,
    id: "44",
    name: "Consolidated Report",
    endpoint: "/report/subscription/unsubscribe/",
  },
  {
    level: 2,
    id: "44",
    name: "Consolidated Report",
    endpoint: "/report/subscription/update/",
  },
  {
    level: 2,
    id: "44",
    name: "Consolidated Report",
    endpoint: "/report/subscription/get/",
  },
  {
    level: 2,
    id: "44",
    name: "Consolidated Report",
    endpoint: "/campaign/spc/report/get/",
  },
  {
    level: 2,
    id: "7043626160646815746",
    name: "Ad Insight Report",
    endpoint: "/report/ad_benchmark/get/",
  },
  {
    level: 2,
    id: "7043626160646815746",
    name: "Ad Insight Report",
    endpoint: "/report/video_performance/get/",
  },
  {
    level: 2,
    id: "7231011733974859777",
    name: "Creative Fatigue Insight",
    endpoint: "/creative_fatigue/get/",
  },
  {
    level: 2,
    id: "50",
    name: "Report App Event",
    endpoint: "/app/track/",
  },
  {
    level: 2,
    id: "50",
    name: "Report App Event",
    endpoint: "/app/batch/",
  },
  {
    level: 2,
    id: "51",
    name: "Report Pixel Event",
    endpoint: "/pixel/track/",
  },
  {
    level: 2,
    id: "51",
    name: "Report Pixel Event",
    endpoint: "/pixel/batch/",
  },
  {
    level: 2,
    id: "7224195155857866754",
    name: "Report Conversion Event",
    endpoint: "/event/track/",
  },
  {
    level: 2,
    id: "60",
    name: "Image Management",
  },
  {
    level: 2,
    id: "61",
    name: "Video Management",
  },
  {
    level: 2,
    id: "62",
    name: "Video Template",
    endpoint: "/video_template/task/create/",
  },
  {
    level: 2,
    id: "62",
    name: "Video Template",
    endpoint: "/video_template/status/get/",
  },
  {
    level: 2,
    id: "63",
    name: "Music management",
  },
  {
    level: 2,
    id: "64",
    name: "Creative tool",
    endpoint: "/creative/status/get/",
  },
  {
    level: 2,
    id: "64",
    name: "Creative tool",
    endpoint: "/creative/quick_optimization/create/",
  },
  {
    level: 2,
    id: "64",
    name: "Creative tool",
    endpoint: "/creative/smart_video/create/",
  },
  {
    level: 2,
    id: "64",
    name: "Creative tool",
    endpoint: "/creative/ads_preview/create/",
  },
  {
    level: 2,
    id: "64",
    name: "Creative tool",
    endpoint: "/creative/video_soundtrack/create/",
  },
  {
    level: 2,
    id: "64",
    name: "Creative tool",
    endpoint: "/creative/image/edit/",
  },
  {
    level: 2,
    id: "64",
    name: "Creative tool",
    endpoint: "/creative/asset/share/",
  },
  {
    level: 2,
    id: "65",
    name: "Get Creative Report",
    endpoint: "/creative/report/get/",
  },
  {
    level: 2,
    id: "66",
    name: "Playable Ads",
  },
  {
    level: 2,
    id: "67",
    name: "Creative Material Verification",
  },
  {
    level: 2,
    id: "68",
    name: "Instant Page Management",
  },
  {
    level: 2,
    id: "69",
    name: "TikTok Posts Management",
  },
  {
    level: 2,
    id: "6110000",
    name: "Creative Recommendation",
  },
  {
    level: 2,
    id: "7050363942434078721",
    name: "Dynamic Scene",
  },
  {
    level: 2,
    id: "7130572512626360322",
    name: "Smart Fix",
  },
  {
    level: 2,
    id: "7176833266039685122",
    name: "File Name Check",
  },
  {
    level: 2,
    id: "70",
    name: "App Management",
  },
  {
    level: 2,
    id: "80",
    name: "Pixel Management",
  },
  {
    level: 2,
    id: "90",
    name: "Catalog Management",
  },
  {
    level: 2,
    id: "91",
    name: "Product Management",
  },
  {
    level: 2,
    id: "92",
    name: "DPA Set Management",
  },
  {
    level: 2,
    id: "94",
    name: "Catalog Video Management",
  },
  {
    level: 2,
    id: "95",
    name: "Template",
  },
  {
    level: 2,
    id: "96",
    name: "Event Source Bind",
  },
  {
    level: 2,
    id: "97",
    name: "Feed",
  },
  {
    level: 2,
    id: "7224195155857915906",
    name: "Diagnostic",
  },
  {
    level: 2,
    id: "100000",
    name: "Create and Update Ad Groups",
    endpoint: "/adgroup/rf/create/",
  },
  {
    level: 2,
    id: "100000",
    name: "Create and Update Ad Groups",
    endpoint: "/adgroup/rf/update/",
  },
  {
    level: 2,
    id: "100000",
    name: "Create and Update Ad Groups",
    endpoint: "/adgroup/rf/estimated/info/",
  },
  {
    level: 2,
    id: "100001",
    name: "Inventory and Orders",
    endpoint: "/rf/inventory/estimate/",
  },
  {
    level: 2,
    id: "100001",
    name: "Inventory and Orders",
    endpoint: "/rf/order/cancel/",
  },
  {
    level: 2,
    id: "100002",
    name: "Tools",
    endpoint: "/rf/contract/query/",
  },
  {
    level: 2,
    id: "100002",
    name: "Tools",
    endpoint: "/rf/delivery/timezone/",
  },
  {
    level: 2,
    id: "12010000",
    name: "Leads Retrieval",
  },
  {
    level: 2,
    id: "12020000",
    name: "Test Leads",
  },
  {
    level: 2,
    id: "13010000",
    name: "Create and Update TCM Account",
    endpoint: "/tcm/order/create/v2/",
  },
  {
    level: 2,
    id: "13020000",
    name: "Read TCM Account",
    endpoint: "/tcm/creator/discover/",
  },
  {
    level: 2,
    id: "13020000",
    name: "Read TCM Account",
    endpoint: "/tcm/similar/creator/",
  },
  {
    level: 2,
    id: "13020000",
    name: "Read TCM Account",
    endpoint: "/tcm/report/get/",
  },
  {
    level: 2,
    id: "13030000",
    name: "Get Creators Onboarding Status and Invite Creators to TCM",
    endpoint: "/tcm/creator/invite/",
  },
  {
    level: 2,
    id: "13030000",
    name: "Get Creators Onboarding Status and Invite Creators to TCM",
    endpoint: "/tcm/creator/status/get/",
  },
  {
    level: 2,
    id: "13040000",
    name: "Send Spark Ads Invitation to Creators and Get the Status",
    endpoint: "/tcm/spark_ad/apply/",
  },
  {
    level: 2,
    id: "13040000",
    name: "Send Spark Ads Invitation to Creators and Get the Status",
    endpoint: "/tcm/spark_ad/status/get/",
  },
  {
    level: 2,
    id: "13040000",
    name: "Send Spark Ads Invitation to Creators and Get the Status",
    endpoint: "/tcm/tt_video/status/",
  },
  {
    level: 2,
    id: "13040000",
    name: "Send Spark Ads Invitation to Creators and Get the Status",
    endpoint: "/tcm/tt_video/apply/",
  },
  {
    level: 2,
    id: "14010000",
    name: "Creator User",
  },
  {
    level: 2,
    id: "14020000",
    name: "Creator Media",
  },
  {
    level: 2,
    id: "14030000",
    name: "Creator Order",
  },
  {
    level: 2,
    id: "15010000",
    name: "Ad Comment Management",
  },
  {
    level: 2,
    id: "15020000",
    name: "Blocked Word Management",
  },
  {
    level: 2,
    id: "17010000",
    name: "Create and Update Automated Rules",
    endpoint: "/optimizer/rule/create/",
  },
  {
    level: 2,
    id: "17010000",
    name: "Create and Update Automated Rules",
    endpoint: "/optimizer/rule/update/",
  },
  {
    level: 2,
    id: "17010000",
    name: "Create and Update Automated Rules",
    endpoint: "/optimizer/rule/batch_bind/",
  },
  {
    level: 2,
    id: "17010000",
    name: "Create and Update Automated Rules",
    endpoint: "/optimizer/rule/update/status/",
  },
  {
    level: 2,
    id: "17020000",
    name: "Read Automated Rules and their Execution Results",
    endpoint: "/optimizer/rule/get/",
  },
  {
    level: 2,
    id: "17020000",
    name: "Read Automated Rules and their Execution Results",
    endpoint: "/optimizer/rule/list/",
  },
  {
    level: 2,
    id: "17020000",
    name: "Read Automated Rules and their Execution Results",
    endpoint: "/optimizer/rule/result/get/",
  },
  {
    level: 2,
    id: "17020000",
    name: "Read Automated Rules and their Execution Results",
    endpoint: "/optimizer/rule/result/list/",
  },
  {
    level: 2,
    id: "18010000",
    name: "Business User",
  },
  {
    level: 2,
    id: "18020000",
    name: "Business Media",
    endpoint: "/business/video/list/",
  },
  {
    level: 2,
    id: "18030000",
    name: "Business Comment",
  },
  {
    level: 2,
    id: "7044139020472942593",
    name: "Business Content",
  },
  {
    level: 2,
    id: "7050363942434095105",
    name: "Create/Manage Offline Events",
    endpoint: "/offline/create/",
  },
  {
    level: 2,
    id: "7050363942434095105",
    name: "Create/Manage Offline Events",
    endpoint: "/offline/update/",
  },
  {
    level: 2,
    id: "7050363942434095105",
    name: "Create/Manage Offline Events",
    endpoint: "/offline/delete/",
  },
  {
    level: 2,
    id: "7050363942434127873",
    name: "Report Offline Events One by One",
    endpoint: "/offline/track/",
  },
  {
    level: 2,
    id: "7068127621543919617",
    name: "Report Offline Events in Bulk",
    endpoint: "/offline/batch/",
  },
  {
    level: 2,
    id: "7224195155857833986",
    name: "Read Offline Events",
    endpoint: "/offline/get/",
  },
  {
    level: 2,
    id: "7050363942434029569",
    name: "Get and Adopt Diagnosis Suggestion",
    endpoint: "/tool/diagnosis/get/",
  },
  {
    level: 2,
    id: "7294180478502846465",
    name: "Read CRM Event Sets",
    endpoint: "/crm/list/",
  },
  {
    level: 3,
    id: "100",
    name: "Read Ad Account Information",
    endpoint: "/advertiser/info/",
  },
  {
    level: 3,
    id: "100",
    name: "Read Ad Account Information",
    endpoint: "/oauth2/advertiser/get/",
  },
  {
    level: 3,
    id: "120",
    name: "Terms and Agreements",
    endpoint: "/term/get/",
  },
  {
    level: 3,
    id: "120",
    name: "Terms and Agreements",
    endpoint: "/term/check/",
  },
  {
    level: 3,
    id: "120",
    name: "Terms and Agreements",
    endpoint: "/term/confirm/",
  },
  {
    level: 3,
    id: "130",
    name: "Pangle Block List Management",
    endpoint: "/pangle_block_list/get/",
  },
  {
    level: 3,
    id: "130",
    name: "Pangle Block List Management",
    endpoint: "/pangle_block_list/update/",
  },
  {
    level: 3,
    id: "140",
    name: "Pangle Audience Packages",
    endpoint: "/pangle_audience_package/get/",
  },
  {
    level: 3,
    id: "150",
    name: "Read Business Center",
    endpoint: "/bc/get/",
  },
  {
    level: 3,
    id: "150",
    name: "Read Business Center",
    endpoint: "/bc/balance/get/",
  },
  {
    level: 3,
    id: "150",
    name: "Read Business Center",
    endpoint: "/bc/transaction/get/",
  },
  {
    level: 3,
    id: "151",
    name: "Create Ad Account",
    endpoint: "/bc/image/upload/",
  },
  {
    level: 3,
    id: "151",
    name: "Create Ad Account",
    endpoint: "/bc/advertiser/create/",
  },
  {
    level: 3,
    id: "151",
    name: "Create Ad Account",
    endpoint: "/advertiser/update/",
  },
  {
    level: 3,
    id: "151",
    name: "Create Ad Account",
    endpoint: "/bc/advertiser/disable/",
  },
  {
    level: 3,
    id: "151",
    name: "Create Ad Account",
    endpoint: "/bc/advertiser/qualification/get/",
  },
  {
    level: 3,
    id: "152",
    name: "Ad Account Balance and Transaction",
    endpoint: "/bc/transfer/",
  },
  {
    level: 3,
    id: "152",
    name: "Ad Account Balance and Transaction",
    endpoint: "/advertiser/balance/get/",
  },
  {
    level: 3,
    id: "152",
    name: "Ad Account Balance and Transaction",
    endpoint: "/advertiser/transaction/get/",
  },
  {
    level: 3,
    id: "153",
    name: "Business Center Asset",
    endpoint: "/bc/asset/get/",
  },
  {
    level: 3,
    id: "153",
    name: "Business Center Asset",
    endpoint: "/bc/asset/admin/get/",
  },
  {
    level: 3,
    id: "153",
    name: "Business Center Asset",
    endpoint: "/bc/asset/assign/",
  },
  {
    level: 3,
    id: "153",
    name: "Business Center Asset",
    endpoint: "/bc/asset/unassign/",
  },
  {
    level: 3,
    id: "153",
    name: "Business Center Asset",
    endpoint: "/bc/asset/partner/get/",
  },
  {
    level: 3,
    id: "153",
    name: "Business Center Asset",
    endpoint: "/bc/asset/member/get/",
  },
  {
    level: 3,
    id: "153",
    name: "Business Center Asset",
    endpoint: "/bc/asset/admin/delete/",
  },
  {
    level: 3,
    id: "153",
    name: "Business Center Asset",
    endpoint: "/bc/pixel/link/update/",
  },
  {
    level: 3,
    id: "153",
    name: "Business Center Asset",
    endpoint: "/bc/pixel/link/get/",
  },
  {
    level: 3,
    id: "153",
    name: "Business Center Asset",
    endpoint: "/bc/pixel/transfer/",
  },
  {
    level: 3,
    id: "153",
    name: "Business Center Asset",
    endpoint: "/asset/bind/quota/",
  },
  {
    level: 3,
    id: "155",
    name: "Business Center Partner Management",
    endpoint: "/bc/partner/asset/get/",
  },
  {
    level: 3,
    id: "155",
    name: "Business Center Partner Management",
    endpoint: "/bc/partner/delete/",
  },
  {
    level: 3,
    id: "155",
    name: "Business Center Partner Management",
    endpoint: "/bc/partner/add/",
  },
  {
    level: 3,
    id: "155",
    name: "Business Center Partner Management",
    endpoint: "/bc/partner/get/",
  },
  {
    level: 3,
    id: "155",
    name: "Business Center Partner Management",
    endpoint: "/bc/partner/asset/delete/",
  },
  {
    level: 3,
    id: "156",
    name: "Business Center Member Management",
    endpoint: "/bc/member/delete/",
  },
  {
    level: 3,
    id: "156",
    name: "Business Center Member Management",
    endpoint: "/bc/member/update/",
  },
  {
    level: 3,
    id: "156",
    name: "Business Center Member Management",
    endpoint: "/bc/member/get/",
  },
  {
    level: 3,
    id: "156",
    name: "Business Center Member Management",
    endpoint: "/bc/member/invite/",
  },
  {
    level: 3,
    id: "157",
    name: "Business Center Billing Group Management",
    endpoint: "/bc/billing_group/update/",
  },
  {
    level: 3,
    id: "157",
    name: "Business Center Billing Group Management",
    endpoint: "/bc/billing_group/get/",
  },
  {
    level: 3,
    id: "157",
    name: "Business Center Billing Group Management",
    endpoint: "/bc/billing_group/create/",
  },
  {
    level: 3,
    id: "157",
    name: "Business Center Billing Group Management",
    endpoint: "/bc/billing_group/advertiser/list/",
  },
  {
    level: 3,
    id: "7078191955347259394",
    name: "Invoice Management",
    endpoint: "/bc/invoice/task/create/",
  },
  {
    level: 3,
    id: "7078191955347259394",
    name: "Invoice Management",
    endpoint: "/bc/invoice/get/",
  },
  {
    level: 3,
    id: "7078191955347259394",
    name: "Invoice Management",
    endpoint: "/bc/invoice/download/",
  },
  {
    level: 3,
    id: "7078191955347259394",
    name: "Invoice Management",
    endpoint: "/bc/invoice/task/get/",
  },
  {
    level: 3,
    id: "7078191955347259394",
    name: "Invoice Management",
    endpoint: "/bc/invoice/unpaid/get/",
  },
  {
    level: 3,
    id: "7078191955347259394",
    name: "Invoice Management",
    endpoint: "/bc/invoice/task/list/",
  },
  {
    level: 3,
    id: "7153155400966176769",
    name: "Asset Group",
    endpoint: "/bc/asset_group/create/",
  },
  {
    level: 3,
    id: "7153155400966176769",
    name: "Asset Group",
    endpoint: "/bc/asset_group/get/",
  },
  {
    level: 3,
    id: "7153155400966176769",
    name: "Asset Group",
    endpoint: "/bc/asset_group/update/",
  },
  {
    level: 3,
    id: "7153155400966176769",
    name: "Asset Group",
    endpoint: "/bc/asset_group/list/",
  },
  {
    level: 3,
    id: "7153155400966176769",
    name: "Asset Group",
    endpoint: "/bc/asset_group/delete/",
  },
  {
    level: 3,
    id: "200",
    name: "Read Campaigns",
    endpoint: "/campaign/get/",
  },
  {
    level: 3,
    id: "200",
    name: "Read Campaigns",
    endpoint: "/campaign/quota/get/",
  },
  {
    level: 3,
    id: "200",
    name: "Read Campaigns",
    endpoint: "/campaign/quota/info/",
  },
  {
    level: 3,
    id: "200",
    name: "Read Campaigns",
    endpoint: "/campaign/spc/get/",
  },
  {
    level: 3,
    id: "200",
    name: "Read Campaigns",
    endpoint: "/campaign/copy/task/check/",
  },
  {
    level: 3,
    id: "201",
    name: "Create and Update Campaigns",
    endpoint: "/campaign/create/",
  },
  {
    level: 3,
    id: "201",
    name: "Create and Update Campaigns",
    endpoint: "/campaign/update/",
  },
  {
    level: 3,
    id: "201",
    name: "Create and Update Campaigns",
    endpoint: "/campaign/status/update/",
  },
  {
    level: 3,
    id: "201",
    name: "Create and Update Campaigns",
    endpoint: "/campaign/spc/create/",
  },
  {
    level: 3,
    id: "201",
    name: "Create and Update Campaigns",
    endpoint: "/campaign/spc/update/",
  },
  {
    level: 3,
    id: "201",
    name: "Create and Update Campaigns",
    endpoint: "/campaign/copy/task/create/",
  },
  {
    level: 3,
    id: "210",
    name: "Read Ad Groups",
    endpoint: "/adgroup/get/",
  },
  {
    level: 3,
    id: "210",
    name: "Read Ad Groups",
    endpoint: "/adgroup/review_info/",
  },
  {
    level: 3,
    id: "210",
    name: "Read Ad Groups",
    endpoint: "/adgroup/quota/",
  },
  {
    level: 3,
    id: "211",
    name: "Create and Update Ad Groups",
    endpoint: "/adgroup/create/",
  },
  {
    level: 3,
    id: "211",
    name: "Create and Update Ad Groups",
    endpoint: "/adgroup/update/",
  },
  {
    level: 3,
    id: "211",
    name: "Create and Update Ad Groups",
    endpoint: "/ad/audience_size/estimate/",
  },
  {
    level: 3,
    id: "211",
    name: "Create and Update Ad Groups",
    endpoint: "/adgroup/status/update/",
  },
  {
    level: 3,
    id: "211",
    name: "Create and Update Ad Groups",
    endpoint: "/adgroup/budget/update/",
  },
  {
    level: 3,
    id: "220",
    name: "Read Ads",
    endpoint: "/ad/get/",
  },
  {
    level: 3,
    id: "220",
    name: "Read Ads",
    endpoint: "/ad/review_info/",
  },
  {
    level: 3,
    id: "220",
    name: "Read Ads",
    endpoint: "/ad/aco/get/",
  },
  {
    level: 3,
    id: "220",
    name: "Read Ads",
    endpoint: "/showcase/product/get/",
  },
  {
    level: 3,
    id: "220",
    name: "Read Ads",
    endpoint: "/showcase/identity/get/",
  },
  {
    level: 3,
    id: "220",
    name: "Read Ads",
    endpoint: "/showcase/region/get/",
  },
  {
    level: 3,
    id: "221",
    name: "Create and Update Ads",
    endpoint: "/ad/create/",
  },
  {
    level: 3,
    id: "221",
    name: "Create and Update Ads",
    endpoint: "/ad/update/",
  },
  {
    level: 3,
    id: "221",
    name: "Create and Update Ads",
    endpoint: "/ad/aco/create/",
  },
  {
    level: 3,
    id: "221",
    name: "Create and Update Ads",
    endpoint: "/ad/aco/update/",
  },
  {
    level: 3,
    id: "221",
    name: "Create and Update Ads",
    endpoint: "/ad/status/update/",
  },
  {
    level: 3,
    id: "221",
    name: "Create and Update Ads",
    endpoint: "/ad/aco/material_status/update/",
  },
  {
    level: 3,
    id: "230",
    name: "Change Log",
    endpoint: "/changelog/task/create/",
  },
  {
    level: 3,
    id: "230",
    name: "Change Log",
    endpoint: "/changelog/task/download/",
  },
  {
    level: 3,
    id: "230",
    name: "Change Log",
    endpoint: "/changelog/task/check/",
  },
  {
    level: 3,
    id: "240",
    name: "Split Test",
    endpoint: "/split_test/promote/",
  },
  {
    level: 3,
    id: "240",
    name: "Split Test",
    endpoint: "/split_test/result/get/",
  },
  {
    level: 3,
    id: "240",
    name: "Split Test",
    endpoint: "/split_test/create/",
  },
  {
    level: 3,
    id: "240",
    name: "Split Test",
    endpoint: "/split_test/end/",
  },
  {
    level: 3,
    id: "240",
    name: "Split Test",
    endpoint: "/split_test/update/",
  },
  {
    level: 3,
    id: "7133464587805999106",
    name: "Negative Keywords",
    endpoint: "/search_ad/negative_keyword/download/",
  },
  {
    level: 3,
    id: "7133464587805999106",
    name: "Negative Keywords",
    endpoint: "/search_ad/negative_keyword/add/",
  },
  {
    level: 3,
    id: "7133464587805999106",
    name: "Negative Keywords",
    endpoint: "/search_ad/negative_keyword/delete/",
  },
  {
    level: 3,
    id: "7133464587805999106",
    name: "Negative Keywords",
    endpoint: "/search_ad/negative_keyword/update/",
  },
  {
    level: 3,
    id: "7133464587805999106",
    name: "Negative Keywords",
    endpoint: "/search_ad/negative_keyword/get/",
  },
  {
    level: 3,
    id: "600",
    name: "Read Image Library",
    endpoint: "/file/image/ad/search/",
  },
  {
    level: 3,
    id: "600",
    name: "Read Image Library",
    endpoint: "/file/image/ad/info/",
  },
  {
    level: 3,
    id: "601",
    name: "Create and Update Images",
    endpoint: "/file/image/ad/upload/",
  },
  {
    level: 3,
    id: "601",
    name: "Create and Update Images",
    endpoint: "/file/image/ad/update/",
  },
  {
    level: 3,
    id: "610",
    name: "Read Video Library",
    endpoint: "/file/video/ad/search/",
  },
  {
    level: 3,
    id: "610",
    name: "Read Video Library",
    endpoint: "/file/video/ad/info/",
  },
  {
    level: 3,
    id: "611",
    name: "Create and Update Videos",
    endpoint: "/file/video/ad/upload/",
  },
  {
    level: 3,
    id: "611",
    name: "Create and Update Videos",
    endpoint: "/file/video/ad/update/",
  },
  {
    level: 3,
    id: "612",
    name: "Generate Thumbnails for Videos",
    endpoint: "/file/video/suggestcover/",
  },
  {
    level: 3,
    id: "630",
    name: "Read music library",
    endpoint: "/file/music/get/",
  },
  {
    level: 3,
    id: "631",
    name: "Upload music file",
    endpoint: "/file/music/upload/",
  },
  {
    level: 3,
    id: "660",
    name: "Read Playable Ads",
    endpoint: "/playable/get/",
  },
  {
    level: 3,
    id: "660",
    name: "Read Playable Ads",
    endpoint: "/playable/validate/",
  },
  {
    level: 3,
    id: "661",
    name: "Create/Manage Playable Ads",
    endpoint: "/playable/upload/",
  },
  {
    level: 3,
    id: "661",
    name: "Create/Manage Playable Ads",
    endpoint: "/playable/save/",
  },
  {
    level: 3,
    id: "661",
    name: "Create/Manage Playable Ads",
    endpoint: "/playable/delete/",
  },
  {
    level: 3,
    id: "680",
    name: "Instant Page Management",
    endpoint: "/page/get/",
  },
  {
    level: 3,
    id: "690",
    name: "Query TikTok Posts",
    endpoint: "/tt_video/info/",
  },
  {
    level: 3,
    id: "691",
    name: "Authorize TikTok Posts",
    endpoint: "/tt_video/authorize/",
  },
  {
    level: 3,
    id: "691",
    name: "Authorize TikTok Posts",
    endpoint: "/tt_video/unbind/",
  },
  {
    level: 3,
    id: "691",
    name: "Authorize TikTok Posts",
    endpoint: "/tt_video/list/",
  },
  {
    level: 3,
    id: "692",
    name: "Create Identity",
    endpoint: "/identity/create/",
  },
  {
    level: 3,
    id: "693",
    name: "Query Identity",
    endpoint: "/identity/get/",
  },
  {
    level: 3,
    id: "693",
    name: "Query Identity",
    endpoint: "/identity/info/",
  },
  {
    level: 3,
    id: "693",
    name: "Query Identity",
    endpoint: "/identity/video/get/",
  },
  {
    level: 3,
    id: "693",
    name: "Query Identity",
    endpoint: "/identity/video/info/",
  },
  {
    level: 3,
    id: "693",
    name: "Query Identity",
    endpoint: "/identity/music/authorization/",
  },
  {
    level: 3,
    id: "693",
    name: "Query Identity",
    endpoint: "/identity/live/get/",
  },
  {
    level: 3,
    id: "7176842096345694209",
    name: "Delete Identity",
    endpoint: "/identity/delete/",
  },
  {
    level: 3,
    id: "6110100",
    name: "CTA Recommendation",
    endpoint: "/creative/portfolio/create/",
  },
  {
    level: 3,
    id: "6110100",
    name: "CTA Recommendation",
    endpoint: "/creative/portfolio/get/",
  },
  {
    level: 3,
    id: "6110100",
    name: "CTA Recommendation",
    endpoint: "/creative/cta/recommend/",
  },
  {
    level: 3,
    id: "6110100",
    name: "CTA Recommendation",
    endpoint: "/creative/portfolio/list/",
  },
  {
    level: 3,
    id: "6110200",
    name: "Smart Text",
    endpoint: "/creative/smart_text/generate/",
  },
  {
    level: 3,
    id: "6110200",
    name: "Smart Text",
    endpoint: "/creative/smart_text/feedback/",
  },
  {
    level: 3,
    id: "7043626160646864898",
    name: "Core Functions",
    endpoint: "/dynamic_scene/material/submit/",
  },
  {
    level: 3,
    id: "7043626160646864898",
    name: "Core Functions",
    endpoint: "/dynamic_scene/task/create/",
  },
  {
    level: 3,
    id: "7043626160646864898",
    name: "Core Functions",
    endpoint: "/dynamic_scene/get/",
  },
  {
    level: 3,
    id: "7043626160646864898",
    name: "Core Functions",
    endpoint: "/dynamic_scene/task/get/",
  },
  {
    level: 3,
    id: "7043626160646864898",
    name: "Core Functions",
    endpoint: "/dynamic_scene/report/get/",
  },
  {
    level: 3,
    id: "7132385893100437506",
    name: "Fix Task management",
    endpoint: "/video/fix/task/create/",
  },
  {
    level: 3,
    id: "7132385893100437506",
    name: "Fix Task management",
    endpoint: "/video/fix/task/get/",
  },
  {
    level: 3,
    id: "700",
    name: "Read Apps",
    endpoint: "/app/list/",
  },
  {
    level: 3,
    id: "700",
    name: "Read Apps",
    endpoint: "/app/info/",
  },
  {
    level: 3,
    id: "700",
    name: "Read Apps",
    endpoint: "/app/optimization_event/",
  },
  {
    level: 3,
    id: "700",
    name: "Read Apps",
    endpoint: "/app/optimization_event/retargeting/",
  },
  {
    level: 3,
    id: "701",
    name: "Create and Update Apps",
    endpoint: "/app/create/",
  },
  {
    level: 3,
    id: "701",
    name: "Create and Update Apps",
    endpoint: "/app/update/",
  },
  {
    level: 3,
    id: "800",
    name: "Read Pixels",
    endpoint: "/pixel/list/",
  },
  {
    level: 3,
    id: "801",
    name: "Create and Update Pixels",
    endpoint: "/pixel/create/",
  },
  {
    level: 3,
    id: "801",
    name: "Create and Update Pixels",
    endpoint: "/pixel/update/",
  },
  {
    level: 3,
    id: "801",
    name: "Create and Update Pixels",
    endpoint: "/pixel/event/create/",
  },
  {
    level: 3,
    id: "801",
    name: "Create and Update Pixels",
    endpoint: "/pixel/event/update/",
  },
  {
    level: 3,
    id: "801",
    name: "Create and Update Pixels",
    endpoint: "/pixel/event/delete/",
  },
  {
    level: 3,
    id: "801",
    name: "Create and Update Pixels",
    endpoint: "/pixel/instant_page/event/",
  },
  {
    level: 3,
    id: "802",
    name: "Pixel Level Reporting",
    endpoint: "/pixel/event/stats/",
  },
  {
    level: 3,
    id: "900",
    name: "Read Catalogs",
    endpoint: "/catalog/get/",
  },
  {
    level: 3,
    id: "900",
    name: "Read Catalogs",
    endpoint: "/catalog/lexicon/get/",
  },
  {
    level: 3,
    id: "900",
    name: "Read Catalogs",
    endpoint: "/catalog/overview/",
  },
  {
    level: 3,
    id: "900",
    name: "Read Catalogs",
    endpoint: "/catalog/location_currency/get/",
  },
  {
    level: 3,
    id: "900",
    name: "Read Catalogs",
    endpoint: "/catalog/available_country/get/",
  },
  {
    level: 3,
    id: "901",
    name: "Create and Update Catalog",
    endpoint: "/catalog/create/",
  },
  {
    level: 3,
    id: "901",
    name: "Create and Update Catalog",
    endpoint: "/catalog/update/",
  },
  {
    level: 3,
    id: "901",
    name: "Create and Update Catalog",
    endpoint: "/catalog/delete/",
  },
  {
    level: 3,
    id: "901",
    name: "Create and Update Catalog",
    endpoint: "/catalog/capitalize/",
  },
  {
    level: 3,
    id: "910",
    name: "Read Products",
    endpoint: "/catalog/product/get/",
  },
  {
    level: 3,
    id: "910",
    name: "Read Products",
    endpoint: "/catalog/product/log/",
  },
  {
    level: 3,
    id: "911",
    name: "Create and Update Product",
    endpoint: "/catalog/product/upload/",
  },
  {
    level: 3,
    id: "911",
    name: "Create and Update Product",
    endpoint: "/catalog/product/delete/",
  },
  {
    level: 3,
    id: "911",
    name: "Create and Update Product",
    endpoint: "/catalog/product/file/",
  },
  {
    level: 3,
    id: "911",
    name: "Create and Update Product",
    endpoint: "/catalog/product/update/",
  },
  {
    level: 3,
    id: "920",
    name: "Get Catalog Set",
    endpoint: "/catalog/set/get/",
  },
  {
    level: 3,
    id: "920",
    name: "Get Catalog Set",
    endpoint: "/catalog/set/product/get/",
  },
  {
    level: 3,
    id: "921",
    name: "Post Catalog Set",
    endpoint: "/catalog/set/create/",
  },
  {
    level: 3,
    id: "921",
    name: "Post Catalog Set",
    endpoint: "/catalog/set/update/",
  },
  {
    level: 3,
    id: "921",
    name: "Post Catalog Set",
    endpoint: "/catalog/set/delete/",
  },
  {
    level: 3,
    id: "940",
    name: "Get Catalog Video",
    endpoint: "/catalog/video_package/get/",
  },
  {
    level: 3,
    id: "941",
    name: "Post Catalog Video",
    endpoint: "/catalog/video_package/update/",
  },
  {
    level: 3,
    id: "941",
    name: "Post Catalog Video",
    endpoint: "/catalog/video_package/create/",
  },
  {
    level: 3,
    id: "941",
    name: "Post Catalog Video",
    endpoint: "/catalog/video_package/delete/",
  },
  {
    level: 3,
    id: "950",
    name: "Template",
    endpoint: "/catalog/template/upload/",
  },
  {
    level: 3,
    id: "950",
    name: "Template",
    endpoint: "/catalog/template_preview/create/",
  },
  {
    level: 3,
    id: "960",
    name: "Read Event Source Bind",
    endpoint: "/catalog/eventsource_bind/get/",
  },
  {
    level: 3,
    id: "960",
    name: "Read Event Source Bind",
    endpoint: "/diagnostic/catalog/eventsource/metric/",
  },
  {
    level: 3,
    id: "960",
    name: "Read Event Source Bind",
    endpoint: "/diagnostic/catalog/eventsource/issue/",
  },
  {
    level: 3,
    id: "961",
    name: "Create and Delete Event Source Bind",
    endpoint: "/catalog/eventsource/bind/",
  },
  {
    level: 3,
    id: "961",
    name: "Create and Delete Event Source Bind",
    endpoint: "/catalog/eventsource/unbind/",
  },
  {
    level: 3,
    id: "970",
    name: "Get Feed",
    endpoint: "/catalog/feed/get/",
  },
  {
    level: 3,
    id: "970",
    name: "Get Feed",
    endpoint: "/catalog/feed/log/",
  },
  {
    level: 3,
    id: "971",
    name: "Post Feed",
    endpoint: "/catalog/feed/create/",
  },
  {
    level: 3,
    id: "971",
    name: "Post Feed",
    endpoint: "/catalog/feed/update/",
  },
  {
    level: 3,
    id: "971",
    name: "Post Feed",
    endpoint: "/catalog/feed/delete/",
  },
  {
    level: 3,
    id: "971",
    name: "Post Feed",
    endpoint: "/catalog/feed/switch/",
  },
  {
    level: 3,
    id: "12010100",
    name: "Leads Retrieval",
    endpoint: "/page/field/get/",
  },
  {
    level: 3,
    id: "12010100",
    name: "Leads Retrieval",
    endpoint: "/page/lead/get/",
  },
  {
    level: 3,
    id: "12020100",
    name: "Test Leads",
    endpoint: "/page/lead/mock/create/",
  },
  {
    level: 3,
    id: "12020100",
    name: "Test Leads",
    endpoint: "/page/lead/mock/get/",
  },
  {
    level: 3,
    id: "12020100",
    name: "Test Leads",
    endpoint: "/page/lead/mock/delete/",
  },
  {
    level: 3,
    id: "12020100",
    name: "Test Leads",
    endpoint: "/page/field/get/",
  },
  {
    level: 3,
    id: "12020100",
    name: "Test Leads",
    endpoint: "/page/lead/task/download/",
  },
  {
    level: 3,
    id: "12020100",
    name: "Test Leads",
    endpoint: "/page/lead/task/",
  },
  {
    level: 3,
    id: "14010100",
    name: "Get Creator Basic Info",
  },
  {
    level: 3,
    id: "14010200",
    name: "Get Creator Insights",
    endpoint: "/tcm/creator/public/",
  },
  {
    level: 3,
    id: "14010200",
    name: "Get Creator Insights",
    endpoint: "/tcm/creator/authorized/",
  },
  {
    level: 3,
    id: "14020100",
    name: "Get Creator Media",
    endpoint: "/tcm/creator/public/video/list/",
  },
  {
    level: 3,
    id: "14020100",
    name: "Get Creator Media",
    endpoint: "/tcm/creator/authorized/video/list/",
  },
  {
    level: 3,
    id: "15010100",
    name: "Read Comments",
    endpoint: "/comment/list/",
  },
  {
    level: 3,
    id: "15010100",
    name: "Read Comments",
    endpoint: "/comment/reference/",
  },
  {
    level: 3,
    id: "15010100",
    name: "Read Comments",
    endpoint: "/comment/task/create/",
  },
  {
    level: 3,
    id: "15010100",
    name: "Read Comments",
    endpoint: "/comment/task/check/",
  },
  {
    level: 3,
    id: "15010100",
    name: "Read Comments",
    endpoint: "/comment/task/download/",
  },
  {
    level: 3,
    id: "15010200",
    name: "Write Comments",
    endpoint: "/comment/status/update/",
  },
  {
    level: 3,
    id: "15010200",
    name: "Write Comments",
    endpoint: "/comment/delete/",
  },
  {
    level: 3,
    id: "15010200",
    name: "Write Comments",
    endpoint: "/comment/post/",
  },
  {
    level: 3,
    id: "15020100",
    name: "Read Blocked Words",
    endpoint: "/blockedword/list/",
  },
  {
    level: 3,
    id: "15020100",
    name: "Read Blocked Words",
    endpoint: "/blockedword/task/create/",
  },
  {
    level: 3,
    id: "15020100",
    name: "Read Blocked Words",
    endpoint: "/blockedword/task/check/",
  },
  {
    level: 3,
    id: "15020100",
    name: "Read Blocked Words",
    endpoint: "/blockedword/task/download/",
  },
  {
    level: 3,
    id: "15020100",
    name: "Read Blocked Words",
    endpoint: "/blockedword/check/",
  },
  {
    level: 3,
    id: "15020200",
    name: "Write Blocked Words",
    endpoint: "/blockedword/create/",
  },
  {
    level: 3,
    id: "15020200",
    name: "Write Blocked Words",
    endpoint: "/blockedword/update/",
  },
  {
    level: 3,
    id: "15020200",
    name: "Write Blocked Words",
    endpoint: "/blockedword/delete/",
  },
  {
    level: 3,
    id: "18010100",
    name: "Get Business User Basic Info",
    endpoint: "/business/get/",
  },
  {
    level: 3,
    id: "18030100",
    name: "Get Business Comment",
    endpoint: "/business/comment/reply/list/",
  },
  {
    level: 3,
    id: "18030100",
    name: "Get Business Comment",
    endpoint: "/business/comment/list/",
  },
  {
    level: 3,
    id: "18030200",
    name: "Manage Business Comment",
    endpoint: "/business/comment/create/",
  },
  {
    level: 3,
    id: "18030200",
    name: "Manage Business Comment",
    endpoint: "/business/comment/delete/",
  },
  {
    level: 3,
    id: "18030200",
    name: "Manage Business Comment",
    endpoint: "/business/comment/hide/",
  },
  {
    level: 3,
    id: "18030200",
    name: "Manage Business Comment",
    endpoint: "/business/comment/reply/create/",
  },
  {
    level: 3,
    id: "18030200",
    name: "Manage Business Comment",
    endpoint: "/business/comment/like/",
  },
  {
    level: 3,
    id: "7050363942433996801",
    name: "Video Publish",
    endpoint: "/business/video/publish/",
  },
  {
    level: 3,
    id: "7050363942433996801",
    name: "Video Publish",
    endpoint: "/business/hashtag/suggestion/",
  },
];
